import type { DisciplineCode } from "../taxonomy";
import type { DrawingKind, NamedDrawing } from "../types";

/**
 * The drawings the demo portfolio's projects list, per discipline, named as their addresses name them
 * (/p/<project>/design/draft/<id>). They are demo content only: a new project starts with no drawings (founder, 4 Nov),
 * in the mock and on the server alike. A project made in this browser's demo data before 4 Nov listed these too, so
 * bringing it to the server (WS-29, `projects/bring-over.ts`) sends them, and a drawing drawn in it keeps its doc
 * service ID.
 */

const DRAWINGS: Readonly<Record<DisciplineCode, readonly [string, DrawingKind][]>> = {
  A: [
    ["Site plan", "site"],
    ["Ground floor plan", "plan"],
    ["First floor plan", "plan"],
    ["Terrace plan", "plan"],
    ["Section A-A", "section"],
    ["Front elevation", "elevation"],
  ],
  I: [
    ["Furniture layout", "plan"],
    ["Reflected ceiling plan", "plan"],
    ["Electrical points", "plan"],
    ["Kitchen elevations", "elevation"],
    ["Wardrobe details", "detail"],
  ],
  L: [
    ["Landscape master plan", "site"],
    ["Planting plan", "plan"],
    ["Grading and drainage", "plan"],
    ["Hardscape details", "detail"],
  ],
  U: [
    ["Layout plan", "layout"],
    ["Plot schedule", "layout"],
    ["Road sections", "section"],
    ["Open space and amenities", "layout"],
  ],
  H: [
    ["Measured ground floor", "plan"],
    ["Condition mapping", "plan"],
    ["Street elevation as found", "elevation"],
  ],
  E: [
    ["Stall plan", "plan"],
    ["Stall elevations", "elevation"],
    ["Fabrication details", "detail"],
  ],
};

/** A drawing's address name: "Section A-A" is section-a-a. */
function drawingSlug(name: string): string {
  return name.toLowerCase().replace(/[^a-z0-9]+/g, "-");
}

export function demoDrawings(discipline: DisciplineCode): NamedDrawing[] {
  return DRAWINGS[discipline].map(([name, kind]) => ({ id: drawingSlug(name), name, kind }));
}
